import { c as _c } from "react/compiler-runtime";
import { memo, useMemo } from 'react';
import type { VaultV2PendingTimelockDecodedData } from '../../types/pendingTimelocks';
import { getDecodedFunctionNameLabel, getTimelockFunctionConfig } from '../utils';
import { StyledVaultPendingTimelock } from '../VaultV2PendingTimelockStyled';
import VaultPendingTimelockHeader from './VaultV2PendingTimelockHeader';
type VaultV2AbdicatePendingData = Extract<VaultV2PendingTimelockDecodedData, {
  __typename: 'VaultV2AbdicatePendingData';
}>;
interface VaultV2PendingTimelockAbdicateProps {
  decodedData: VaultV2AbdicatePendingData;
  functionName: string;
}
const VaultV2PendingTimelockAbdicate = t0 => {
  const $ = _c(12);
  const {
    functionName,
    decodedData
  } = t0;
  let t1;
  if ($[0] !== functionName) {
    t1 = getTimelockFunctionConfig({
      functionName
    });
    $[0] = functionName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    criticality
  } = t1;
  let t2;
  if ($[2] !== decodedData.functionName) {
    t2 = getDecodedFunctionNameLabel(decodedData.functionName);
    $[2] = decodedData.functionName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const label = t2;
  let t3;
  if ($[4] !== criticality) {
    t3 = <VaultPendingTimelockHeader title="Abdicate" criticality={criticality} />;
    $[4] = criticality;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-2xs text-foreground">Action</span>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== label) {
    t5 = <StyledVaultPendingTimelock.Row>{t4}<span className="text-2xs text-foreground">{label}</span></StyledVaultPendingTimelock.Row>;
    $[7] = label;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="flex flex-col">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default memo(VaultV2PendingTimelockAbdicate);